import { isCordova } from "./isCordova";

export const getAppVersion = async () => {
  try {
    if (
      isCordova() &&
      window.cordova &&
      window.cordova.getAppVersion
    ) {
      return await window.cordova.getAppVersion.getVersionNumber();
    }

    // Browser version
    return "2.2.0";
  } catch (error) {
    console.error(error);
    return "2.2.0";
  }
};